import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';

export default function NavbarDropdown({ label, items }) {
  return (
    <Menu as="div" className="relative inline-block text-left z-10">
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="text-gray-300 hover:text-white inline-flex justify-center w-full rounded-md shadow-sm px-4 py-2 text-lg font-medium">
              {label}
              <ChevronDownIcon
                className="-mr-1 ml-2 mt-1.5 h-5 w-5"
                aria-hidden="true"
              />
            </Menu.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="bg-gray-800 origin-top-right absolute right-0 mt-2 py-1 w-56 shadow-2xl rounded-md"
            >
              {items.map((item, idx) => (
                <Menu.Item
                  className="text-gray-300 hover:text-white block px-4 py-2 text-lg"
                  key={`dropdown-link-${idx}`}
                >
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.label}
                  </a>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
